<template>
  <div>
     <!-- header头部 -->
    <Header title='Terms & Rules'  menuState :skipPath='skipPath' backgroundColor="#424040" fontColor="#fff">
    </Header>
           <div class="main"  >
            <p style="text-align:center; font-size:16px;margin-bottom:10px;">
                <b>New User Offer Rules</b>
            </p>
            <p>
               1) All offers displayed on this page can only bought by new users who didn’t purchase any products on Kilimall app or website.
            </p>
            <p>
               2) New user can only buy one of those products sold at 1 shilling.
            </p>
            <p>
               3) New user can buy several products from the "Price for New User Only" zone as many as possible.
            </p>
            <p>
               4) All frauds are not acceptable.
            </p>
             
            <p>
                Kilimall reserves all rights.
            </p>
        </div>
  </div>
</template>

<script>
import Header from "@/components/header/header.vue";
export default {
  components: {
    Header,
  },
}
</script>

<style lang='scss' scoped>
 .main{
        overflow: auto;
        padding: 20px /* 40/72 */;
        font-size: $font-size-18;
        box-sizing: border-box;
        color: $font-color-01;
        p{
            margin-top:10px;
            font-size:$font-size-14;
        }
    }
</style>